export default __webpack_public_path__ + "static/media/Image-12.ed676656.png";